import * as React from 'react';
import { Handle, NodeProps, Node, Position } from '@xyflow/react';
import { DetailNode } from '../detail-node/detail-node.component';
import { floatingHandleStyles } from '../../styles/floating-handle-styles';

export const DecisionNode = (props: NodeProps<Node<{ label: string }>>) => {
  const { data, isConnectable = true, id } = props;

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        data-testid="decision-node-handle-top"
        style={floatingHandleStyles.targetTop}
      />
      <DetailNode label={data.label} type="decision" id={id} />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        id={`${id}_true`}
        style={floatingHandleStyles.decisionTrue}
        data-testid="decision-node-handle-true"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        id={`${id}_false`}
        style={floatingHandleStyles.decisionFalse}
        data-testid="decision-node-handle-false"
      />
    </>
  );
};
